<template>
    <GaleryComponent />
</template>

<script>
import GaleryComponent from '@/components/GaleryComponent.vue';

export default {
  components: {
    GaleryComponent
  }
}
</script>
